import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { SubscriptionDetails, SubscriptionGroup } from "../types/subscriptionTypes";

const initialState: SubscriptionGroup = {
  razorpay: {
    free: [],
    business: [],
    enterprise: [],
  },
  stripe: {
    free: [],
    business: [],
    enterprise: [],
  },
  zoho_link: null,
  loading: false,
  error: null,
  details: null,
};

const subscriptionsSlice = createSlice({
  name: "subscriptions",
  initialState,
  reducers: {
    // Define a reducer and automatically generate its action
    setSubscriptions(state, action: PayloadAction<SubscriptionGroup>) {
      // Add defensive programming to prevent undefined errors
      state.razorpay = action.payload.razorpay || {
        free: [],
        business: [],
        enterprise: [],
      };
      state.stripe = action.payload.stripe || {
        free: [],
        business: [],
        enterprise: [],
      };
      state.zoho_link = action.payload.zoho_link || null;
    },
    setSubscriptionLoading: (
      state: SubscriptionGroup,
      action: PayloadAction<boolean>,
    ) => {
      state.loading = action.payload;
    },
    setSubscriptionError: (
      state: SubscriptionGroup,
      action: PayloadAction<string>,
    ) => {
      state.error = action.payload;
    },
    setSubscriptionDetails: (
      state: SubscriptionGroup,
      action: PayloadAction<SubscriptionDetails | null>,
    ) => {
      state.details = action.payload;
    },
  },
});

// Export the automatically generated action creators
export const {
  setSubscriptions,
  setSubscriptionLoading,
  setSubscriptionError,
  setSubscriptionDetails,
} = subscriptionsSlice.actions;

// Export the reducer
export default subscriptionsSlice.reducer;
